import { match as BlogMonthOrDay } from "../../../src/params/BlogMonthOrDay.ts";
import { match as BlogPostSlug } from "../../../src/params/BlogPostSlug.ts";
import { match as BlogTag } from "../../../src/params/BlogTag.ts";
import { match as BlogYear } from "../../../src/params/BlogYear.ts";

export const matchers = { BlogMonthOrDay, BlogPostSlug, BlogTag, BlogYear };